
exports = module.exports = require('./lib/ab-testing');

exports.version = require('./package.json').version;